import Api from "../../../../services/Api";

function logDownload(serialNumber, fileName) {
  return Api.get(`service/evse_management/api/v1/evse/${serialNumber}/download_ocpp_logs?file_name=${fileName}`);
}

export { logDownload };
